<template>
  <div class="col-md-12">
    <div v-if="currentProduct" class="card card-container">
      <h4><font-awesome-icon icon="edit" /> Edit Product Details</h4>
      <form name="form" @submit.prevent="updateProduct">
        <div v-if="!successful">
          <div class="form-group">
            <label for="name">Name:</label>
            <input v-model="currentProduct.name" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="name" name="name"/>
            <div v-if="submitted && errors.has('name')" class="alert-danger" >{{errors.first('name')}}</div>
          </div>
          <div class="form-group">
            <label for="sv">SV:</label>
            <input v-model="currentProduct.sv" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="sv" name="sv"/>
            <div v-if="submitted && errors.has('sv')" class="alert-danger" >{{errors.first('sv')}}</div>
          </div>
          <div class="form-group">
            <label for="pv">PV:</label>
            <input v-model="currentProduct.pv" v-validate="'required'" type="number" class="form-control" id="pv" name="pv"/>
            <div v-if="submitted && errors.has('pv')" class="alert-danger" >{{errors.first('pv')}}</div>
          </div>
          <div class="form-group">
            <label for="description">Description:</label>
            <input v-model="currentProduct.description" v-validate="'required|min:3|max:255'" type="text" class="form-control" id="description" name="description"/>
            <div v-if="submitted && errors.has('description')" class="alert-danger" >{{errors.first('description')}}</div>
          </div>
          <div class="form-group">
            <label for="unitPrice">Unit Price:</label>
            <input v-model="currentProduct.unitPrice" v-validate="'required'" type="number" class="form-control" id="unitPrice" name="unitPrice"/>
            <div v-if="submitted && errors.has('unitPrice')" class="alert-danger" >{{errors.first('unitPrice')}}</div>
          </div>
          <div class="form-group">
            <label for="costPrice">Cost Price:</label>
            <input v-model="currentProduct.costPrice" v-validate="'required'" type="number" class="form-control" id="costPrice" name="costPrice"/>
            <div v-if="submitted && errors.has('costPrice')" class="alert-danger" >{{errors.first('costPrice')}}</div>
          </div>          
          <div class="form-group">
            <button class="badge badge-danger mr-2" @click="deleteProduct"><font-awesome-icon icon="trash-alt" /> Delete</button>
            <button type="submit" class="badge badge-success mr-2"><font-awesome-icon icon="save" /> Update</button>
            <button class="badge badge-primary" @click="productsList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="productsList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
      </div>
    </div>
    <div v-else>
      <br />
      <p>Please click on a Product...</p>
    </div>
  </div>
</template>

<script>
import ProductService from "../services/product.service";

export default {
  name: 'product',
  data() {
    return {
      currentProduct: null,
      submitted: false,
      successful: false,
      message: '',
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    getProduct(id) {
      ProductService.get(id)
        .then(response => {
          this.currentProduct = response.data;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    updateProduct() {
      this.message = '';
      this.submitted = true;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          ProductService.update(this.currentProduct.id, this.currentProduct).then(
            response => {
              console.log(response.data);
              this.message = 'The product was updated successfully!';
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log(e);
            });
        }
      });
    },

    deleteProduct() {
      ProductService.delete(this.currentProduct.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "products" });
        })
        .catch(e => {
          console.log(e);
        });
    },

    productsList() {
      this.$router.push('/products');
    }
  },
  mounted() {
    this.message = '';
    this.getProduct(this.$route.params.id);
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>